/* BAZ add to cart -> native Horizon cart drawer.
   Every BAZ add button (product page, quick add on cards, spotlight) calls window.bazCartAdd(formData, sourceEl).
   It announces the add with the same standard event Horizon's own product form uses, so the native
   drawer slides in straight away, re-renders with the new line and the header count updates. */
import { CartLinesUpdateEvent } from '@shopify/events';

const drawer = () => document.getElementById('cart-drawer');
const onCartPage = () => document.body.classList.contains('template-cart') || location.pathname.replace(/\/$/, '').endsWith('/cart');

const openDrawer = () => {
  const d = drawer();
  if (d && typeof d.open === 'function' && !d.isOpen && !onCartPage()) d.open();
};

/**
 * @param {FormData} body  must contain `id` (variant id); `quantity` defaults to 1
 * @param {Element} [source]  element the event is dispatched from
 * @returns {Promise<object>} the added item, or throws { description } on failure
 */
window.bazCartAdd = async (body, source = document.body) => {
  if (!body.get('quantity')) body.set('quantity', '1');
  const quantity = Number(body.get('quantity')) || 1;
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  if (sectionIds.length) body.set('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(body.get('id')), quantity }],
    promise: deferred.promise,
  }));
  /* slide the drawer in instantly; its contents fill in as soon as the cart responds */
  openDrawer();

  let res, json;
  try {
    res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url ? Theme.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
    json = await res.json().catch(() => ({}));
  } catch (e) {
    res = { ok: false }; json = {};
  }
  const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => null);
  deferred.resolve({
    cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined,
    detail: { items: cart ? cart.items : [], sections: res.ok ? json.sections : undefined, didError: !res.ok, source: 'baz', itemCount: quantity },
  });
  if (cart) document.dispatchEvent(new CustomEvent('baz:cart-updated', { detail: { count: cart.item_count } }));
  if (!res.ok) throw { description: json.description || json.message || 'Could not add to cart. Please try again.' };
  openDrawer();
  return json;
};
window.bazHasDrawer = () => Boolean(drawer()) && !onCartPage();
